import React from "react";
import classnames from 'classnames';

const CustomAccordianHeader = (props) => {
    return (
        <h2 className="accordion-header" id="headingOne">
            <button
                className={classnames(
                    "accordion-button zIndexes",
                    // "fw-medium",
                    {
                        collapsed: props?.handleAccordion !== props?.keyId,
                    }
                )}
                type="button"
                onClick={() => props?.onClick(props?.keyId)}
                style={{ cursor: "pointer",height: 40 }}
            >
                {props?.title}
            </button>
        </h2>
    )
}

export default CustomAccordianHeader;